class RelatedProductsRz extends HTMLElement {
    observer = undefined;

    constructor() {
        super();
        this.carousel = null;

        // Handle resize events to recalculate carousel
        window.addEventListener('resize', this.debounce(() => {
            if (this.carousel) {
                this.carousel.destroy(true, true);
                this.toggleCarousel();
            }
        }, 250));
    }

    connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                this.loadRecommendations(productId);
            },
            { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
    }

    loadRecommendations(productId) {
        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations-rz');

                if (recommendations?.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }

                this.onLoad();
            })
            .catch((e) => {
                console.error(e);
            });
    }

    onLoad() {
        this.columnsDesktop = parseInt(this.getAttribute('data-columns-desktop')) || 4;
        this.columnsMobile = parseInt(this.getAttribute('data-columns-mobile')) || 2;
        this.carouselMobile = this.getAttribute('data-carousel-mobile') === 'true';
        this.carouselLoop = this.getAttribute('data-carousel-loop') === 'true';
        this.showNavigation = this.getAttribute('data-show-navigation') === 'true';
        this.showDots = this.getAttribute('data-show-dots') === 'true';

        setTimeout(() => {
            this.toggleCarousel();
        }, 100);
    }

    /**
     * Initialize the carousel with Swiper
     */
    toggleCarousel() {
        const container = this.querySelector('.product-carousel-items');
        if (!container) {
            console.error('Carousel container not found');
            return;
        }

        try {
            // Desktop media query
            const media = window.matchMedia('(min-width: 750px)');

            if (media.matches || this.carouselMobile === true) {
                const carouselItemCount = this.querySelectorAll('.product-carousel-item').length;
                const minCarouselItems = Math.max(this.columnsDesktop, this.columnsMobile);

                const options = {
                    slidesPerView: this.columnsMobile,
                    spaceBetween: 16,
                    slidesPerGroup: this.columnsMobile,
                    watchOverflow: true,
                    a11y: true,
                    loop: this.carouselLoop && carouselItemCount > minCarouselItems,
                    centerInsufficientSlides: true,
                    breakpoints: {
                        750: {
                            slidesPerView: this.columnsDesktop,
                            spaceBetween: 20,
                            slidesPerGroup: this.columnsDesktop
                        }
                    }
                };

                if (this.showNavigation) {
                    options.navigation = {
                        nextEl: this.querySelector('.product-carousel-button-next'),
                        prevEl: this.querySelector('.product-carousel-button-prev')
                    };
                }

                if (this.showDots) {
                    options.pagination = {
                        el: this.querySelector('.product-carousel-pagination'),
                        clickable: true
                    };
                }

                this.carousel = new Swiper(container, options);
                console.log('Carousel initialized successfully');
            }
        } catch (error) {
            console.error('Error initializing carousel:', error);
        }
    }

    /**
     * Debounce function to limit how often a function can be called
     */
    debounce(fn, delay) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(context, args), delay);
        };
    }
}

customElements.define('product-recommendations-rz', RelatedProductsRz);